import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { SubStringRezEnum } from '@/modules/ojeteVozy/constants';

import { NAME as name, CRUMB_LABEL_KEY, PovDruhEnum } from '../constants';
import { apiProvider } from '../api';
import { listMutations } from './types';

const filter = {
	DoplnekMk: null as string | null,
	DokladOd: null as string | null,
	DokladDo: null as string | null,
	PovDruh: null as PovDruhEnum | null,
	Otevrene: null as boolean | null,
	Uvolnene: null as boolean | null,
	Uzavrene: null as boolean | null,
	ProvozovnaId: null as number | null,
	UzavDatOd: null as Date | null,
	UzavDatDo: null as Date | null,
	ZakaznikId: null as number | null,
	ZakaznikIdText: null as string | null,
	PovNr: null as string | null,
	KomiseovNr: null as string | null,
	OvprijemkaNr: null as string | null,
	OvprijemkaPfx: null as string | null,
	OvvydejkaNr: null as string | null,
	OvvydejkaPfx: null as string | null,
	VyrobekvozOzn: null as string | null,
	Typkod: null as string | null,
	TypkodText: null as string | null,
	SerialNrOd: null as string | null,
	SerialNrDo: null as string | null,
	KaroserieNr: null as string | null,
	VinSubstr: null as SubStringRezEnum | null,
	VstupDatOd: null as Date | null,
	VstupDatDo: null as Date | null,
	KVymazu: null as boolean | null,
	NezavZaj: null as boolean | null,
	NezavPopt: null as boolean | null,
	ZavPopt: null as boolean | null,
	BezZak: null as boolean | null,
	NezavazVoz: null as boolean | null,
	ZavazVoz: null as boolean | null,
	UvolnVoz: null as boolean | null,
	ProdaneVoz: null as boolean | null,
	NeniPrijato: null as boolean | null,
	Naskladneni: null as boolean | null,
	NaSklade: null as boolean | null,
	Vyskladneno: null as boolean | null,
	PrijemKom: null as boolean | null,
	VKomisi: null as boolean | null,
	Vydano: null as boolean | null,
	SkladVoz: null as boolean | null,
	KomisVoz: null as boolean | null,
	POVCleared: null as boolean | null,
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		VyrobekvozOzn: [],
	},
	filter,
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[listMutations.ZAKAZNIK_SELECT_MAPPER](state, { data }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikIdText = data.text;
		},
		[listMutations.TYPKOD_SELECT_MAPPER](state, { data }) {
			state.filter.Typkod = data.typkod;
			state.filter.TypkodText = data.text;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
